import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { ResultDownloadFormComponent } from './result-download-form/result-download-form.component';
import { ResultDownloadListComponent } from './result-download-list/result-download-list.component';

@NgModule({
  declarations: [
    ResultDownloadListComponent,
    ResultDownloadFormComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class ResultDownloadModule { }
